<script
  lang="ts"
  setup
>
import GridViewIcon from '@/components/icons/GridViewIcon.vue'
import ListViewIcon from '@/components/icons/ListViewIcon.vue'
import WaterfallIcon from '@/components/icons/WaterfallIcon.vue'
import useDisplayMode from '~/composables/useDisplayMode'

import { ViewType } from '~/types/enum'

const iconMap = {
  [ViewType.GRID]: GridViewIcon,
  [ViewType.LIST]: ListViewIcon,
  [ViewType.FLOW]: WaterfallIcon,
}

const emits = defineEmits<{
  change: []
}>()

const { viewType } = useDisplayMode()

const handleViewTypeChange = (val: ViewType) => {
  emits('change')
  viewType.value = val
}
</script>

<template>
  <ul class="view-type-list">
    <li
      v-for="(item, key) in iconMap"
      :key="key"
      :class="[ viewType === key && 'active' ]"
      class="view-mode-item"
      @click="() => handleViewTypeChange(key)"
    >
      <component
        :is="item"
        color="#666666"
      />
      <span>{{ $t(`view-mode-type-${key}`) }}</span>
    </li>
  </ul>
</template>

<style lang="less">
.view-type-list {
  min-width: unset;

  .view-mode-item {
    display: flex;
    align-items: center;
    padding: 0 10px;
    cursor: pointer;
    width: auto;
    border-radius: 4px;
    height: 48px;
    line-height: 1.5;
    gap: 12px;
    white-space: nowrap;

    &.active {
      background-color: #f8f8f8;
    }

    &:hover {
      background-color: #f8f8f8;
    }
  }
}

@media screen and (max-width: 768px) {
  .view-type-list {
    .view-mode-item {
      gap: 12px;
      padding: 0 16px;
      min-height: 40px;
      height: 40px;

      &:hover {
        background-color: unset;
      }

      &.active {
        background: url(@/assets/images/share/selected.svg) no-repeat 172px center / 20px;
      }
    }
  }
}
</style>
